<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      {{ group.name }}
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-expansion-panels>
        <accordion-services-group
          v-for="stage in group.stages"
          v-bind:key="stage.id"
          v-bind:group="stage"
          v-on:select-service="onSelectService"
        />
      </v-expansion-panels>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import AccordionServicesGroup from '@/components/AccordionServicesGroup.vue';

/**
 * @description Группа услуг по этапам для аккордеона.
 * @type {string}
 */
const NAME_EVENT_SELECT_SERVICE = 'select-service';

/**
 * @description Выбор услуг из этапов
 */
export default {
  components: { AccordionServicesGroup },
  methods: {
    /**
     * @description Обработать выбор услуги.
     * @param {Object} service     Услуга.
     * @param {boolean} isSelected Выбрана.
     * @returns {void}
     */
    onSelectService(service, isSelected) {
      this.$emit(NAME_EVENT_SELECT_SERVICE, service, isSelected);
    },
  },
  name: 'AccordionStagesGroup',
  props: {
    /**
     * @description Список сгруппированных услуг.
     * @type {id:number,name:string,services:Object[],stages:Object[]}
     */
    group: {
      required: true,
      type: Object,
    },
  },
};
</script>
